import { useTranslation } from "react-i18next";
import Process from "../components/Process";

export default function ProcessPage() {
  const { t } = useTranslation();

  return (
    <>
      <div className="mx-auto max-w-7xl px-4 pt-16">
        <h1 className="text-4xl font-bold">{t("process.heading")}</h1>
        <p className="mt-2 text-slate-600">{t("process.subheading")}</p>
      </div>

      {/* Full process (all steps from i18n) */}
      <Process anchor={false} showTitle={false} className="bg-transparent" />

      {/* If you ever want a compact teaser elsewhere:
         <Process anchor={false} showTitle={true} maxSteps={4} />
      */}
    </>
  );
}
